import PropTypes from "prop-types";
import {
  Backdrop,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  ListItemText,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
// eslint-disable-next-line import/named
import { geojsons, Region, Countries } from "assets/geojson";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  ADD_ITEMS,
  BUILDIN,
  CLEAR_ITEMS,
  DRAW,
  SELECTED_DATA,
  SET_SUBMIT_CLICKED,
  SUBMIT_GEOJSON,
  // SET_SUBMIT_STATUS,
} from "store/actions";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Draw, Snap } from "ol/interaction";
import * as ol from "ol";
import GeoJSON from "ol/format/GeoJSON";
import axios from "axios";
import MKButton from "../../components/MKButton";
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";
import GridCard from "../Cards/GridCard";
import clearFlashingFeaturesLayer from "../../utils/clearFlashingFeaturesLayer";
import HTTP_API from "../../store/constant/httpApi";

const GridCardSelectData = ({ productionInfo, map }) => {
  const dispatch = useDispatch();

  // Draw是否完毕的状态
  const [DrawStatus, setDrawStatus] = useState(false);

  // 是否正在Draw的状态
  const [DrawingStatus, setDrawingStatus] = useState(false);

  // Submit提交后台的Geojson
  const [SubmitGeojson, setSubmitGeojson] = useState({});

  // 提交的状态
  const [SubmitStatus, setSubmitStatus] = useState(false);

  // 绘制source、vectorLayer、draw事件、添加Draw和清除Draw
  const source = new VectorSource({ useSpatialIndex: false });
  const geojsonFormat = new GeoJSON();
  const drawVector = new VectorLayer({
    className: "draw",
    zIndex: 1,
    source,
    style: {
      "stroke-color": "rgba(255,51,58,0.84)",
      "stroke-width": 2,
    },
  });
  const draw = new Draw({
    source,
    type: "Polygon",
  });
  draw.on("drawend", (event) => {
    drawVector.getSource().clear();
    const feature = new ol.Feature({
      geometry: event.feature.getGeometry(),
    });
    drawVector.getSource().addFeature(feature);
    // 将Vector图层中的Feature转换为GeoJSON格式
    const geojson = geojsonFormat.writeFeaturesObject(drawVector.getSource().getFeatures());
    setSubmitGeojson(geojson);
    setDrawStatus(true);
    setDrawingStatus(false);
  });
  const snap = new Snap({ source });

  const clearDrawFeature = () => {
    const drawedVector = map
      .getLayers()
      .getArray()
      .find((t) => t.getClassName() === "draw");
    if (drawedVector) {
      map.removeLayer(drawedVector);
    }
    map.getInteractions().removeAt(10);
    map.getInteractions().removeAt(9);
    setDrawStatus(false);
    setDrawingStatus(false);
    setSubmitStatus(false);
    setSubmitGeojson({});
  };

  const addDrawFeature = () => {
    clearDrawFeature();
    map.getLayers().extend([drawVector]);
    map.addInteraction(draw);
    map.addInteraction(snap);
    setDrawingStatus(true);
  };

  // 从colletion中读取年份信息
  let years = productionInfo.extent.temporal.interval.map(
    (item) =>
      item[0].match(/^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})T(?<time>.*)$/).groups.year
  );
  years = [...new Set(years)];

  // 选择年份的state和handle
  const [Selection, setSelection] = useState([]);
  const handleSelectionChange = (e) => {
    const {
      target: { value },
    } = e;
    setSelection(typeof value === "string" ? value.split(",") : value);
    setSubmitStatus(false);
  };

  // 选择buildin roi方式时的geojson获取
  const selectedValueRef = useRef(null);
  const [SelectRegionValue, setSelectRegionValue] = useState("");

  const handleMenuItemClick = (e, item) => {
    setSelectRegionValue(item);
    dispatch({ type: BUILDIN, value: item });
    selectedValueRef.current.value = item;
    setSubmitStatus(false);
    dispatch({ type: DRAW, value: false });
  };

  useEffect(() => {
    if (SelectRegionValue !== "") {
      const feature = geojsons.filter((a) => a.name === SelectRegionValue)[0].json;
      const geojson = geojsonFormat.writeFeaturesObject(new GeoJSON().readFeatures(feature));
      setSubmitGeojson(geojson);
    }
  }, [SelectRegionValue]);

  // 选择roi的方式buildin/draw
  const [RoiType, setRoiType] = useState("buildin");
  const handleRoiTypeChange = (e) => {
    dispatch({ type: BUILDIN, value: "" });
    clearDrawFeature();
    setRoiType(e.target.value);
    setSelectRegionValue("");
    setSubmitStatus(false);
  };

  const Prepared =
    !SubmitStatus &&
    (SelectRegionValue !== "" || DrawStatus) &&
    !DrawingStatus &&
    Selection.length > 0;

  const handleReset = () => {
    clearFlashingFeaturesLayer(map, "flashingFeaturesLayer");
    setSubmitStatus(false);
    setSelectRegionValue("");
    setSelection([]);
    setRoiType("buildin");
    clearDrawFeature();
    dispatch({ type: BUILDIN, value: "" });
    dispatch({ type: SELECTED_DATA, value: [] });
    dispatch({ type: DRAW, value: false });
    dispatch({ type: CLEAR_ITEMS });
  };

  const [submitBackdrop, setSubmitBackdrop] = useState(false);
  const handleBackdropClose = () => {
    setSubmitBackdrop(false);
  };
  const handleBackdropOpen = () => {
    setSubmitBackdrop(true);
  };

  const mapSubmit = () => {
    dispatch({ type: SET_SUBMIT_CLICKED, value: true });
    if (RoiType !== "draw") {
      map.getInteractions().removeAt(10);
      map.getInteractions().removeAt(9);
      setDrawStatus(false);
      setDrawingStatus(false);
      setSubmitStatus(false);
    } else {
      map.getInteractions().removeAt(10);
      map.getInteractions().removeAt(9);
    }

    dispatch({ type: CLEAR_ITEMS });
    dispatch({ type: SELECTED_DATA, value: Selection });
    dispatch({ type: DRAW, value: RoiType === "draw" });

    clearFlashingFeaturesLayer(map, "flashingFeaturesLayer");
    dispatch({ type: SUBMIT_GEOJSON, value: SubmitGeojson });
    const geom = new GeoJSON().readFeatures(SubmitGeojson)[0].getGeometry();
    map.getView().fit(geom, {
      padding: [50, 50, 50, 50],
    });
    const geojson4326 = new GeoJSON().writeGeometry(geom.transform("EPSG:3857", "EPSG:4326"));
    handleBackdropOpen();
    const promises = Selection.map(async (a) => {
      const firstOfYear = `${a}-01-01T00:00:00.000Z`;
      const lastOfYear = `${a}-12-31T23:59:59.999Z`;

      try {
        const response = await axios.post(`${HTTP_API.STAC}/search`, {
          intersects: JSON.parse(geojson4326),
          datetime: `${firstOfYear}/${lastOfYear}`,
          collections: [productionInfo.id],
        });
        dispatch({ type: ADD_ITEMS, id: a, features: response.data.features });
        // dispatch({ type: SET_SUBMIT_STATUS, value: false });
        return response.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    });
    Promise.all(promises)
      .then(() => {
        // dispatch({ type: SET_SUBMIT_STATUS, value: true });
        dispatch({ type: SET_SUBMIT_CLICKED, value: false });
        setSubmitStatus(true);
        handleBackdropClose();
      })
      .catch(console.error);
  };

  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 48);
    }
  }, [parentRef]);

  return (
    <GridCard title="Select Data" ref={parentRef}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={submitBackdrop}
      >
        <CircularProgress color="white" />
      </Backdrop>
      <MKBox maxHeight={maxHeight} sx={{ height: 1, m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
        <Grid2 container>
          <Grid2
            container
            xs={12}
            sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, justifyContent: "center" }}
          >
            <MKBox sx={{ minWidth: 120 }}>
              <FormControl sx={{ mx: 1 }}>
                <RadioGroup value={RoiType} onChange={handleRoiTypeChange}>
                  <FormControlLabel value="buildin" control={<Radio />} label="Select a region" />

                  <FormControl size="small">
                    <Select
                      value={SelectRegionValue}
                      ref={selectedValueRef}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      sx={{ height: "30px", width: "180px" }}
                      defaultValue=""
                      disabled={RoiType !== "buildin"}
                    >
                      <MenuItem value="" disabled>
                        None
                      </MenuItem>
                      {Region.map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={(event) => handleMenuItemClick(event, item)}
                        >
                          {item}
                        </MenuItem>
                      ))}
                      <MenuItem disabled>
                        <MKTypography>Regional Member Countries</MKTypography>
                      </MenuItem>
                      {Countries.map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={(event) => handleMenuItemClick(event, item)}
                        >
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControlLabel
                    value="draw"
                    control={<Radio />}
                    label="Draw a polygon"
                    sx={{ mt: { lg: 0.5, xxl: 1, xxxl: 2 } }}
                  />
                  <Grid2 container>
                    <Grid2 xs={6}>
                      <MKButton
                        variant="outlined"
                        color="secondary"
                        size="small"
                        onClick={addDrawFeature}
                        disabled={DrawStatus || RoiType !== "draw"}
                        sx={{ mx: 1 }}
                      >
                        Draw
                      </MKButton>
                    </Grid2>
                    <Grid2 xs={6}>
                      <MKButton
                        variant="outlined"
                        color="secondary"
                        size="small"
                        sx={{ mx: 1 }}
                        onClick={clearDrawFeature}
                        disabled={!DrawStatus || RoiType !== "draw"}
                      >
                        Clear
                      </MKButton>
                    </Grid2>
                  </Grid2>
                </RadioGroup>
              </FormControl>
            </MKBox>
          </Grid2>
          <Grid2
            container
            xs={12}
            sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, justifyContent: "center" }}
          >
            <FormControl variant="outlined" sx={{ mx: 1 }}>
              <FormLabel id="multipe-select-year-label">Select years</FormLabel>
              <Select
                labelId="multipe-select-year-label"
                id="multipe-select-year"
                multiple
                value={Selection}
                onChange={handleSelectionChange}
                input={<OutlinedInput />}
                sx={{ height: "30px", width: "180px" }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      width: "180px",
                    },
                  },
                }}
                renderValue={(selected) => selected.join(", ")}
              >
                {years.map((data) => (
                  <MenuItem key={data} value={data}>
                    <Checkbox checked={Selection.indexOf(data) > -1} />
                    <ListItemText primary={data} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <Tooltip title="2.Select year" arrow> */}
            {/*   <HelpOutlineIcon color="info" /> */}
            {/* </Tooltip> */}
          </Grid2>
          <Grid2
            container
            xs={12}
            sx={{ m: { lg: 0.5, xxl: 1, xxxl: 2 }, justifyContent: "center" }}
          >
            <FormControl variant="outlined" sx={{ mx: 1 }}>
              <Grid2 container>
                <Grid2 xs={6}>
                  <MKButton
                    variant="contained"
                    color="secondary"
                    component="a"
                    size="small"
                    disabled={!Prepared}
                    onClick={() => {
                      mapSubmit();
                    }}
                    sx={{ mx: 1 }}
                  >
                    Submit
                  </MKButton>
                </Grid2>
                <Grid2 xs={6}>
                  <MKButton
                    variant="contained"
                    color="secondary"
                    component="a"
                    size="small"
                    disabled={!SubmitStatus}
                    onClick={handleReset}
                    sx={{ mx: 1 }}
                  >
                    RESET
                  </MKButton>
                </Grid2>
              </Grid2>
            </FormControl>
            {/* <Tooltip title="3.Submit to get results, or reset selection." arrow> */}
            {/*   <HelpOutlineIcon color="info" /> */}
            {/* </Tooltip> */}
          </Grid2>
        </Grid2>
      </MKBox>
    </GridCard>
  );
};

GridCardSelectData.defaultProps = {
  productionInfo: {},
  map: undefined,
};

GridCardSelectData.propTypes = {
  productionInfo: PropTypes.objectOf(PropTypes.any),
  map: PropTypes.oneOfType([PropTypes.any]),
};
export default GridCardSelectData;
